<template>
  <div class="payment pay">
    <!-- 导航栏 -->
    <div class="navPay">
      <van-nav-bar title="微信支付" left-arrow>
        <van-icon
          name="wap-home-o"
          slot="left"
          style="color: black"
          @click="$router.push('/')"
        />
      </van-nav-bar>
    </div>
    <!-- 商品信息 -->
    <div class="ctxPay">
      <!-- <div class="titlePay">天天生鲜商品</div> -->

      <div>
        <img :src="qrcode" alt="" />
      </div>

      <div class="pricePay">￥{{ allFee | formatMoney }}</div>
    </div>
    <!-- 收款方 -->
    <div class="context">
      <div class="collectPay">
        <div class="leftPay">收款方</div>
        <div class="rightPay">天堂电子商务有限公司</div>
      </div>

      <div class="collectPay">
        <div class="leftPay">剩余支付时间</div>
        <div class="rightPay">
          <TimeBox :createTime="createTime" @getCount="getCount" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeBox from "@/components/TimeBox";
export default {
  components: {
    TimeBox,
  },
  data() {
    return {
      count: 0,
      time: "",
      timer: null,
      orderId: this.$route.query.orderId,
      createTime: this.$route.query.createTime,
      allFee: this.$route.query.allFee,
      qrcode: this.$route.query.qrcode,
    };
  },

  created() { 
    this.createWs();
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    createWs() {
      let env = process.env.NODE_ENV;
      let wsurl = env==='development'?'localhost:3003':'43.136.85.99:3003';
      var ws = new WebSocket(`ws://${wsurl}/ws?id=` + this.orderId);
      // 响应onmessage事件:
      ws.onmessage = (msg) => {
        let data = JSON.parse(msg.data);
        if (data.orderStatus) {
          if (data.orderStatus == '01') {
            this.$dialog
              .alert({
                message: "支付成功",
              })
              .then(() => {
                this.$router.push("/order/list");
              });
          } else {
            this.$dialog
              .alert({
                message: "支付失败",
              })
              .then(() => {
                this.$router.push("/order/list");
              });
          }
        }
      };
      ws.onopen = () => {
        // 给服务器发送一个字符串:
        ws.send("Hello!");
      };
    },

    getCount(count) {
      this.count = count;
    },

    async waitResult() {
      // 根据轮询结果
      this.timer = setInterval(async () => {
        let res = await this.$axios.post("/order/detail", {
          orderId: this.orderId,
        });
        if (res.result.orderStatus === "01") {
          clearInterval(this.timer);
          // 支付成功, 跳转订单页面
          this.$router.push("/order/list");
        }
      }, 2000);
    },
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
.navPay .van-nav-bar {
  height: 44px;
  line-height: 44px;
}
</style>